/*
 * @Author: wangbaihe
 * @Date: 2024-03-15 15:35:33
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-12-12 19:04:23
 * @FilePath: \common-mediax\src\apis\MediaCloudArticleMy\ArticleEdit.js
 * @Description: 个人稿库api文件
 */
import { createAPI } from '@common'

// MediaCloudArticleMyEdit
export default {
  // 列表下载
  putDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0epxompbe', 'post', config, {
      timeout: 86400000
    }),
  // 个人库资源树获取
  getRootFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0nzbsujdmf0sppu', 'get', config),
  getRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0f60gpmefst0sppu', 'get', config),
  getSubs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0f60benjo0epn0gpmefst', 'get', config),
  // 写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bsujdmf0feju0joju', 'get', config),
  getNoticeInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0joju', 'get', config),
  postNoticePush: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0opujdfQvti', 'post', config),
  deleteArticlemyNotice: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0efmfuf', 'post', config),
  getSystemNoticeOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0pqujpot', 'get', config),
  // 写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bsujdmf0feju0tbwf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 获取稿件详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bsujdmf0feju0efubjm', 'get', config, {
      timeout: 90000
    }),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bsujdmf0feju0efubjm', 'GET', config, {
      timeout: 90000
    }),
  getNoticeDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0efubjm', 'get', config),
  // 删除稿件
  deleteArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0efmfuf', 'delete', config),
  // 删除稿件
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0efmfuf', 'DELETE', config),
  // 提交稿件（个人稿库）
  submitArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0tvcnju', 'post', config, {
      timeout: 90000
    }),
  //跨租户提交（融合生产稿源库mediax-articleorigin）
  submitArticleOrigin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0tvcnjuUijse',
      'post',
      config,
      { timeout: 120000, noHideLoading: true }
    ),
  //跨租户提交（融合生产部门库mediax-articleedit）
  submitArticleEdit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0bdujpot0tvcnjuUijse',
      'post',
      config,
      { timeout: 120000, noHideLoading: true }
    ),
  //跨租户提交（融合生产审稿库mediax-articleaudit）
  submitArticleAudit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  //跨租户提交（融合发布app、mediax-articleapp）
  submitArticleApp: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmft0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  //跨租户提交（融合发布web、mediax-articleapp）
  submitArticleWeb: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bsujdmfxfct0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  //跨租户提交（融合发布微信、/mediax-articlewx）
  submitArticleWx: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0bsujdmft0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  //跨租户提交（融合发布微博）
  submitArticleWb: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjcp0bsujdmft0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  //跨租户提交（融合发布视频）
  submitArticleVideo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  //跨租户提交（融合发布媒体号）
  submitArticleOthers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  //跨租户提交（融合发布报纸）
  submitArticlePaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0tvcnjuUijse', 'post', config, {
      timeout: 120000,
      noHideLoading: true
    }),
  // 打印
  putPrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0qsjou', 'put', config),
  // 打印
  postArticlePrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0qsjou', 'put', config),
  // 密送稿件
  mysendArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0nztfoe', 'post', config),

  postSaveNotice: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0tztufnOpujdf0dsfbuf!', 'post', config),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),

  // 追回列表
  getRecoverList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0sfdpwfs0mjtu', 'get', config),
  // 追回操作
  postRecover: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0sfdpwfs', 'post', config, {
      timeout: 120000
    }),
  // 还原已删除稿件
  postArticleRevert: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0bsujdmfSfwfsu',
      'post',
      config,
      vconfig
    ),
  // 彻底删除已删除稿件
  postArticleDeleteReal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bdujpot0efmfufSfbm', 'post', config, vconfig),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 获取详情页操作按钮
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0f60bdujpot0efubjmbdujpot', 'get', config)
}
